import React from "react";

import { CREATOR_DASHBOARD_PHOTOS_PENDING } from "data/links";
import { useCurrentUser } from "contexts/CurrentUserContext";
import colors from "core/colors";

import {
    Container,
    Title,
    Message,
    Buttons,
    Button,
    IconContainer
} from "./styles";
import QueueIcon from "core/IllustrativeIcons/Queue";

const MaxQueueError = () => {
    const user = useCurrentUser();
    const username = (user && user.username) || "";
    return (
        <Container>
            <Title>Your prior submissions are queued for review.</Title>
            <Message>
                Thanks for your patience. Your prior submissions must be
                reviewed before you can add more.
            </Message>
            <Buttons>
                <Button
                    href={CREATOR_DASHBOARD_PHOTOS_PENDING.replace(
                        ":username",
                        username
                    )}
                >
                    See Submission Status
                </Button>
            </Buttons>
            <IconContainer>
                <QueueIcon fillColor={colors.accent.lightMode.pansy} />
            </IconContainer>
        </Container>
    );
};

export default MaxQueueError;
